"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.Alert = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _reactDom = _interopRequireDefault(require("react-dom"));

var _ProductThemeProvider = _interopRequireDefault(require("../ProductThemeProvider"));

var _SnackBar = _interopRequireDefault(require("../SnackBar"));

var _GuidHelper = require("./GuidHelper");

var SnackbarWithState = function SnackbarWithState(props) {
  var _useState = (0, _react.useState)(true),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      isOpen = _useState2[0],
      setIsOpen = _useState2[1];

  return /*#__PURE__*/_react.default.createElement(_SnackBar.default, (0, _extends2.default)({
    open: isOpen,
    onClose: function onClose() {
      return setIsOpen(false);
    }
  }, props));
};

var Alert = {
  showError: function showError(message, resetErrorCallback) {
    resetErrorCallback && resetErrorCallback();
    return Alert.show(message, "error");
  },
  showSuccess: function showSuccess(message) {
    return Alert.show(message, "success");
  },
  show: function show(message, variant) {
    var origin = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {
      horizontal: "right",
      vertical: "bottom"
    };
    // eslint-disable-next-line no-console
    console.warn("The Alert utility has been deprecated in favor of the enqueueSnackbar function of notistack.");
    var container = document.createElement("div");
    var id = (0, _GuidHelper.generateGuid)();
    container.setAttribute("id", id);
    document.body.appendChild(container);

    _reactDom.default.render( /*#__PURE__*/_react.default.createElement(_ProductThemeProvider.default, null, /*#__PURE__*/_react.default.createElement(SnackbarWithState, {
      id: "".concat(id, "-snackbar"),
      message: {
        message: message,
        variant: variant
      },
      anchorOrigin: origin,
      onExited: function onExited() {
        return _reactDom.default.unmountComponentAtNode(container);
      },
      autoHideDuration: 5000
    })), container);
  }
};
exports.Alert = Alert;
var _default = Alert;
exports.default = _default;